/**
 * 仅用于测试的接口
 */
import Axios from '@/components/api/axios.js'
export default {
	/*历史值接口*/
	historyValueSql(sql,success,failure){
		Axios.post('/test/historyValueSql.do', {
		  sql,
		}, success, failure)
	}
}